import actionTypes from '../constants/action-types';
import hdrm from '../../hdrm';

const disableView = () => (next) => (action) => {
  switch (action.type) {
    case actionTypes.SET_DISABLED_STATUS: {
      const value = action.payload;
      const { driver } = hdrm.instance;
      const liveDocument = driver.getLiveDocument();
      liveDocument.documentElement.style.pointerEvents = value ? 'none' : 'auto';

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default disableView;
